
export enum ETargetAutoFill {
    SUBJECT = 'subject',
    EDITOR = 'editor'
}
